import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction, editTaskConstant } from 'src/redux/actions/constant';
import myAvailabilityServices from 'src/services/apiServices/my-availability-services/my-availability-services';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  EDIT_TASK_THERAPIST_SCHEDULING_REQUEST,
  EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS,
  EDIT_TASK_THERAPIST_SCHEDULING_FAILURE,
  EDIT_TASK_THERAPIST_SCHEDULING_RESET,
  EDIT_TASK_THERAPIST_SCHEDULING_LOADING,
} = editTaskConstant;

function* therapistSchedulingTaskEdit(action: any): SagaReturnType<any> {
  try {
    yield put({ type: EDIT_TASK_THERAPIST_SCHEDULING_LOADING });
    const response = yield call(
      therapistSchedulingServices.therapistSchedulingTaskEdit,
      action.payload
    );
    if (response?.status === 200) {
      yield put({ type: EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS, payload: response.data });
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST,
        payload: {
          providerId: action.payload.providerId,
          localDate: action.payload.currentDate,
          data: { isV2: action.payload.data?.isV2 },
        },
      });
      if (action.payload.data?.isV2)
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST,
          payload: {
            data: {
              providerId: action.payload?.providerId,
              localDate: action.payload?.currentDate,
              type: action.payload.data?.selectedTaskType || '',
              skill: '',
              active: true,
              isV2: action.payload.data?.isV2,
              // THIN-7718: refresh the board the user is looking at, not the edited task's
              // own discipline. data.discipline is the task's discipline (and is part of
              // the edit request body), so requesting the list for it would fetch the wrong
              // board — and now that off-discipline responses are rejected, the refresh
              // would simply be dropped, leaving a stale queue after a reschedule.
              discipline: action.payload?.refetchDiscipline || action.payload.data?.discipline,
            },
            pageNo: action.payload.data?.pageNo,
          },
        });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: EDIT_TASK_THERAPIST_SCHEDULING_FAILURE, payload: error });
  }
}

function* therapistSchedulingTaskEditSaga() {
  yield takeEvery(EDIT_TASK_THERAPIST_SCHEDULING_REQUEST, therapistSchedulingTaskEdit);
}

export default therapistSchedulingTaskEditSaga;
